<div [class]="dir" *ngIf="pageReady">
  <app-header></app-header>
  <app-banner id="home"></app-banner>
  <app-steps id="steps"></app-steps>
  <app-features id="features"></app-features>
  <app-card-type id="cardtype"></app-card-type>
  <app-demo id="demo"></app-demo>
  <app-faq id="faq"></app-faq>
  <app-footer id="contactus"></app-footer>
  <app-toast></app-toast>
  <app-tawk></app-tawk>
</div>
